import React, {useEffect, useMemo} from "react";
import ReportUtils from "../../../../../../utils/report-utils.js";


const EncounterCards = ({data, teamEncounter, isLeader, boName}) => {
  const reportName = isLeader ? "Abordagens dos subordinados" : "Abordagens";

  const labels = useMemo(() => [
    "Abordagens realizadas",
    "Abordagens por plantão",
    `${boName} com abordagem`,
    "Participações indiretas",
    "Indivíduos abordados",
    "Veículos abordados",
  ], [boName]);

  useEffect(() => {
    const rows = [];
    rows.push(data.total ?? 0);
    rows.push(data.encounter_avg ?? 0);
    rows.push(data.encounter_bo ?? 0);
    !isLeader && rows.push(teamEncounter ?? 0);
    rows.push(data.individuals ?? 0);
    rows.push(data.vehicles ?? 0);

    const labelsToSend = !isLeader ? labels : labels.filter(el => el !== "Abordagens em que participou");

    ReportUtils.createExportableTable(labelsToSend, rows, reportName);
  }, [data, teamEncounter, isLeader]);

  return(
    <>
      <div className="report-divisor">
        <span className="divisor-title">{reportName.toUpperCase()}</span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div className="mb-1 mt-3 cursor-pointer">
          <div className="text-center">
            <div className="box boxCount">
              <h3>{labels[0]}</h3><h2>{data.total ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-3 cursor-pointer">
          <div className="text-center">
            <div className="box">
              <h3>{labels[1]}</h3><h2>{data.encounter_avg ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-3 cursor-pointer">
          <div className="text-center">
            <div className="box">
              <h3>{labels[2]}</h3><h2>{data.encounter_bo ?? 0}</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 justify-content-center align-items-center">
        {!isLeader &&
          <div className="mb-1 mt-1 cursor-pointer" title="Apenas como integrante da guarnição">
            <div className="text-center">
              <div className="box">
                <h3>{labels[3]}</h3><h2>{teamEncounter ?? 0}</h2>
              </div>
            </div>
          </div>
        }
        <div className="mb-1 mt-1 cursor-pointer">
          <div className="text-center">
            <div className="box">
              <h3>{labels[4]}</h3><h2>{data.individuals ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-1 cursor-pointer">
          <div className="text-center">
            <div className="box">
              <h3>{labels[5]}</h3><h2>{data.vehicles ?? 0}</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="chart-divisor"></div>
    </>
  )
}

export default EncounterCards;